import { OriginalClonePair } from '../types';

export const exportEveryTextBackgroundImage = async (
  clonedNodes: OriginalClonePair<TextNode>[],
  withTexts = false
): Promise<{ [nodeId: string]: Uint8Array | null } | null> => {
  const originalOpacity: { [key: string]: number } = {};
  const images: { [key: string]: Uint8Array | null } = {};

  try {
    if (!withTexts) {
      for (const textNode of clonedNodes) {
        if (!textNode) continue;
        originalOpacity[textNode.clone.id] = textNode.clone.opacity;
        textNode.clone.opacity = 0;
      }
    }

    for (const textNode of clonedNodes) {
      if (!textNode) continue;

      try {
        const converted = await textNode.clone.exportAsync({
          format: 'PNG',
          constraint: {
            type: 'SCALE',
            value: 1,
          },
          useAbsoluteBounds: true,
          contentsOnly: false,
        });
        images[textNode.clone.id] = converted;
      } catch {
        images[textNode.clone.id] = null;
      }
    }

    if (!withTexts) {
      for (const textNode of clonedNodes) {
        if (!textNode) continue;
        textNode.clone.opacity = originalOpacity[textNode.clone.id];
      }
    }

    return images;
  } catch {
    if (!withTexts) {
      for (const textNode of clonedNodes) {
        if (!textNode) continue;
        textNode.clone.opacity = originalOpacity[textNode.clone.id];
      }
    }

    return null;
  }
};
